// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"0f545210","61":"bc8590dd","79":"986ca659","216":"69c01854","313":"28949e57","327":"0960d712","371":"74db3698","453":"ceb3aa79","455":"6fdd6226","529":"3cdfa37d","540":"b2668e1b","574":"93f24ce3","609":"401bb0a4","961":"047b7795"}[chunkId] + ".chunk.js";
};